import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';
import whenVisible from 'Utils/whenVisible.js';
import analytics from 'Scripts/analytics.js';
import calendly from 'Scripts/calendly.js';

document.addEventListener('DOMContentLoaded', () => {
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.toggle('is-loaded');
	});

	/* Handle mobile navigation */
	document.querySelector('.navbar-burger')?.addEventListener('click', event => {
		event.preventDefault();

		/* Toggle button appearance */
		document.querySelector('.navbar-burger')?.classList.toggle('is-active');
		/* Toggle menu visibility */
		document.documentElement.classList.toggle('has-menu-active');
		/* Hide any previous submenu */
		document.documentElement.classList.remove('has-submenu-active');

		return false;
	});

	// Apply class when element is visible
	whenVisible();

	analytics.trackTaggedAnchors();
	calendly.setUpCalendly();
});
